export default __webpack_public_path__ + "static/media/camera.8f2f63a1.svg";